import React from 'react';
import ServiceFeatureCard from '../../ui/ServiceFeatureCard';
import { Feature } from '../../../types/service';

interface ServiceFeaturesProps {
  title: string;
  features: Feature[];
  color: string;
}

const ServiceFeatures: React.FC<ServiceFeaturesProps> = ({ title, features, color }) => {
  return (
    <section className="mb-16">
      <h2 className="text-2xl font-bold mb-8">{title}</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <ServiceFeatureCard
            key={index}
            iconName={feature.iconName}
            title={feature.title}
            description={feature.description}
            color={color}
          />
        ))}
      </div>
    </section>
  );
};

export default ServiceFeatures;